<template>
  <div
    :style="{
      'padding-left': px + 'px',
      'padding-right': px + 'px',
      'padding-top': paddingY,
      'padding-bottom': paddingY,
      'flex-grow': grow ? 1 : 0,
      display: flex ? 'flex' : null,
      'background-color': color,
      'text-align':
        right || textRight ? 'right' : center || textCenter ? 'center' : ''
    }"
    style="width:100%"
    :class="{
      sep: separator,
      gutter: gutter,
      baseline: baseline,
      mouseover: isMouseOver,
      titlebar: titleBar
    }"
    class="root"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "HiRow",
  props: {
    px: {
      type: Number,
      default: 15
    },
    py: {
      type: Number,
      default: 0
    },
    /**
     * set py=5px
     */
    pySm: {
      type: Boolean
    },
    /**
     * set py=15px
     */
    pyMd: {
      type: Boolean
    },
    /**
     * set py=30px
     */
    pyLg: {
      type: Boolean
    },
    grow: {
      type: Boolean
    },
    flex: {
      type: Boolean
    },
    /**
     * background color
     */
    color: {
      type: String
    },
    separator: {
      type: Boolean
    },
    /**
     * space between each item (10px)
     */
    gutter: {
      type: Boolean
    },
    right: {
      type: Boolean
    },
    textRight: {
      type: Boolean
    },
    center: {
      type: Boolean
    },
    textCenter: {
      type: Boolean
    },
    baseline: {
      type: Boolean
    },
    /**
     * enable mouse enter/leave event
     */
    mouseMove: {
      type: Boolean
    },
    titleBar: {
      type: Boolean
    }
  },
  data() {
    return {
      isMouseOver: false
    };
  },
  computed: {
    paddingY() {
      let p = 0;
      if (this.py) p = this.py;
      else if (this.pyLg) p = 30;
      else if (this.pyMd) p = 15;
      else if (this.pySm) p = 5;

      if (p === 0) return null;
      else return p + "px";
    }
  },
  mounted() {
    if (this.mouseMove) {
      this.$el.addEventListener("mouseenter", this.mouseEnter);
      this.$el.addEventListener("mouseleave", this.mouseLeave);
    }
  },
  methods: {
    mouseEnter() {
      // console.log("enter");
      this.isMouseOver = true;
    },
    mouseLeave() {
      // console.log("leave");
      this.isMouseOver = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/global.scss";
.sep {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.gutter > *:not(:first-child) {
  margin-left: 10px;
}
.baseline {
  align-items: baseline;
}
.middle {
}
.root {
  transition: background-color 0.5s;
}
.titlebar {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  background-color: $light5;
  color: #51504f;
  min-height: 48px;
}
</style>
